
<template>
  <vs-popup class="holamundo" popup-class="w-9/12" :title="title" :active.sync="popupActive">
    <form>
      <div class="vx-row mb-6">
        <div class="vx-col w-full">
          <Tree
            id="my-tree-id"
            ref="tree1"
            :custom-options="myCustomOptions"
            :custom-styles="myCustomStyles"
            :nodes="options2"
          ></Tree>
          <!-- <v-tree
            ref="tree1"
            :multiple="true"
            :selectAlone="true"
            :halfcheck="false"
            :allowGetParentNode="true"
            :data="options"
          />-->
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="submitForm">ذخیره</vs-button>
        </div>
      </div>
    </form>
  </vs-popup>
</template>
<style>
hr {
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  width: 110%;
  margin: 12px 0 3px;
}
[dir="rtl"] .ltr-input * {
  direction: ltr;
}
[dir="rtl"] .ltr-datepicker {
  direction: ltr;
}
[dir="rtl"] .ltr-datepicker input {
  border: 1px solid #dadada;
}
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
</style>
<script>
import Tree from "vuejs-tree";
//import { VTree, VSelectTree } from "vue-tree-halower";
//import "@/assets/scss/vuexy/extraComponents/tree.scss";

export default {
  name: "edit-permissions",
  props: { forUser: false },
  components: {
    //VTree,
    Tree
  },
  data() {
    return {
      popupActive: false,
      permissions1: {},
      //options: [],
      options2: [],
      title: "",
      ownerId: null,
      grantedPermissionNames: []
    };
  },
  watch: {
    popupActive: {
      handler: function(p1, p2) {
        if (p2) this.options2 = [];
      }
    }
  },
  methods: {
    submitForm() {
      let loading = this.$vs.loading();
      let payload = {
        id: this.ownerId,
        grantedPermissionNames: this.$refs.tree1
          .getCheckedNodes(["id"], false)
          .map(x => x.id)
        // this.$refs.tree1
        // .getNodes()
        // .filter(x => x.checked || x.halfcheck)
        // .map(x => x.id)
      };
      const path = this.forUser
        ? "User/UpdateUserPermissions"
        : "Role/UpdateGrantedPermissions";
      this.$http
        .put("/api/services/app/" + path, payload)
        .then(response => {
          if (response.data.success == true) {
            this.popupActive = false;
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "مجوزها با موفقیت ذخیره شد"
            });
            this.$emit("success");
          }
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    show(id, name) {
      this.permissions1 = {};
      if (id) {
        this.title = `ویرایش مجوزهای ${
          this.forUser ? "کاربر" : "نقش"
        } "${name}"`;
        this.ownerId = id;
        this.get(id);
        this.popupActive = true;
      }
    },
    async get(id) {
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          id: id
        }
      };
      const path = this.forUser
        ? "User/GetUserPermissionsForEdit"
        : "Role/GetRoleForEdit";
      this.$http
        .get("/api/services/app/" + path, payload)
        .then(async response => {
          this.permissions1 = response.data.result.permissions;
          this.grantedPermissionNames =
            response.data.result.grantedPermissionNames;
          //this.options = [];
          //this.traverse(null, this.options);
          this.options2 = [];
          this.traverse2(null, this.options2);
          //   //this.$refs.tree1.uncheckAllNodes();
          //   let ttt=this.$refs.tree1.getNodesData("id");
          //  this.$refs.tree1.getNodesData("id").forEach(x => {
          //   console.log(x)
          //     this.$refs.tree1.checkNode(x);
          //   });
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    // traverse(parentName, children) {
    //   this.permissions1
    //     .filter(x => {
    //       return parentName ? parentName == x.parentName : !x.parentName;
    //     })
    //     .forEach(x => {
    //       let child = {
    //         title: x.displayName,
    //         expanded: true,
    //         nocheck: !parentName,
    //         id: x.name,
    //         checked: this.grantedPermissionNames.includes(x.name),
    //         children: []
    //       };
    //       children.push(child);
    //       this.traverse(x.name, child.children);
    //     });
    // },
    traverse2(parentName, nodes) {
      this.permissions1
        .filter(x => {
          return parentName ? parentName == x.parentName : !x.parentName;
        })
        .forEach(x => {
          let node = {
            text: x.displayName,
            id: x.name,
            state: {
              checked: this.grantedPermissionNames.includes(x.name),
              expanded: true,
              selected: false
            },
            nodes: []
          };
          nodes.push(node);
          this.traverse2(x.name, node.nodes);
        });
    }
  },
  computed: {
    myCustomStyles() {
      return {
        tree: {
          height: "auto",
          maxHeight: "300px",
          overflowY: "visible",
          display: "inline-block"
        }
      };
    },
    myCustomOptions() {
      return {
        events: {
          expanded: {
            state: true
          },
          checked: {
            state: true
          }
        },
        showTags: true
      };
    }
  }
};
</script>